import { useEffect } from 'react';

const APP_NAME = 'Admin Portal';

export function usePageTitle(title) {
    useEffect(() => {
        const newTitle = String(title || '').trim();
        const newTitleApp = newTitle ? `${newTitle} | ${APP_NAME}` : APP_NAME;
        document.title = newTitleApp;
    }, [title]);
    return null;
}
